import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/tired': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM377.1 152.2c3.8 4.4 3.9 11 0.1 15.5l-33.6 40.3 33.6 40.3c3.8 4.5 3.7 11-0.1 15.5-3.5 4.1-9.9 5.7-15.3 2.5l-80-48c-3.6-2.2-5.8-6.1-5.8-10.3s2.2-8.1 5.8-10.3l80-48c5-2.9 11.5-1.9 15.3 2.5zM220 208c0 4.2-2.2 8.1-5.8 10.3l-80 48c-5.4 3.2-11.8 1.6-15.3-2.5-3.8-4.5-3.9-11-0.1-15.5l33.6-40.3-33.6-40.3c-3.8-4.5-3.7-11 0.1-15.5 3.8-4.4 10.3-5.5 15.3-2.5l80 48c3.6 2.2 5.8 6.1 5.8 10.3zM248 272c45.4 0 100.9 38.3 107.8 93.3 1.5 11.9-7 21.6-15.5 17.9-22.7-9.7-56.3-15.2-92.3-15.2s-69.6 5.5-92.3 15.2c-8.6 3.7-17-6.1-15.5-17.9 6.9-55 62.4-93.3 107.8-93.3z'
      }
    ]
  }
})
